module.exports = __webpack_public_path__ + "static/media/searchbar_icon.418838f2.svg";